export let defaultItemsPerPage = 8;

export let allowedItemsPerPage = [defaultItemsPerPage, 16, 24];

export let defaultFirstPage = 1;
